// extracted by mini-css-extract-plugin
module.exports = {"root":"root--WJOOq","search":"search--fnhw2"};